<template>
    <div class="form-group">
        <div class="d-flex w-100 mt-4 align-items-center" style="height: 50px;">
            <input
                v-model="checkbox"
                @click="checkbox = !checkbox"
                type="checkbox" class="toggle" >
            <label class="block mb-0 mt-1" @click="checkbox = !checkbox" style="cursor:pointer;">
                {{ $t('klient.text_46') }}
            </label>
            <div class="info">
                <div class="my_tooltip"> 
                    {{ $t('klient.text_47') }}
                </div>
                <div class="tooltip_hover info_icon">
                    <img src="/img/create_offer/info.svg" alt="">
                </div>
            </div>
            <div v-show="checkbox" class="ml-4" style="width: 270px;">
                <div class="d-flex justify-content-end">
                    <date-picker type="date" v-model="pripomenutemail" format="DD.MM.YYYY" placeholder="dd.mm.rrrr" valueType="format"
                        :disabled-date="notBeforeToday">
                    </date-picker>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker'
export default {
    props: ["pripomenut_email"],
    components: {
            DatePicker,
        },
    data() {
        return {
            pripomenutemail: this.pripomenut_email,
            checkbox: false
        };
    },
    created() {
        if (this.pripomenut_email == null || this.pripomenut_email == "") {
            this.checkbox = false;
        } else {
            this.checkbox = true;
        }
    },
    watch: {
        checkbox: function() {
            if (!this.checkbox) {
                this.pripomenutemail = "";
            }
        },
        pripomenutemail(){
            this.$emit('sendData', this.pripomenutemail);
        }
    },
    mounted () {
        $( ".tooltip_hover" ).hover(
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '1');
            },
            function() {
                $( this ).parent().find('.my_tooltip').css('opacity', '0');
            },
        );
    },
    methods: {
        notBeforeToday(date) {
            return date < new Date(new Date().setHours(0, 0, 0, 0));
        },
    },
};
</script>
<style lang="scss" scoped>
.form-group{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 560px;
    margin: 0 auto;
}
label{
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #212541;
}
input[type="checkbox"] {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    margin: 0px 10px 0 0px;
    background: #C7D4EB;
    border-radius: 25px;
}
.toggle{
    height: 22px;
    width: 40px;
    display: inline-block;
    position: relative;
    margin: 0;
    border: none;
    background: #FFFFFF;
    border-radius: 3px;
    transition: all 0.2s ease;
    &:focus {
        outline: 0;
    }
    &:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }
    &:checked {
        border-color: #2ED8B6;
        background: #2ED8B6;
    }
    &:checked:after {
        transform: translatex(20px);
        
    }
}
.info{
    position: relative;
    height: 20px;
    margin-left: 10px;
    .info_icon{
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img{
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip{
        bottom: 22px;
        right: -7px;
    }
}
.agree_tooltip{
    position: relative;
}
.my_tooltip{
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #F3385A;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity .5s ease-in-out;
    &::after{
        content: '';
        width: 15px;
        height: 15px;
        background: #F3385A;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>